import { PropsWithChildren } from "react";
import { Link as GatsbyLink } from "gatsby";
import { textLink } from "./styles.css";
import { TextLink as SharedTextLink } from "../../../../shared/components/link/TextLink";

export const UnderlinedTextLink = ({
  children,
  to,
}: PropsWithChildren<{ to: string }>) => (
  <GatsbyLink className={textLink} to={to}>
    {children}
  </GatsbyLink>
);

export const TextLink = SharedTextLink;
